var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "user-guide-video-preview.3ecc5b26.png","uri@3x": __webpack_public_path__ + "user-guide-video-preview.5df9cd36.png","uri@2x": __webpack_public_path__ + "user-guide-video-preview.6abdc1f5.png",
    width: 200,
    height: 126
});